module.exports = __webpack_public_path__ + "static/media/noImageAvailable.86bd217e.svg";